module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/foilGlitteryGold-14342a25c0dabb883a45e5aa71669ba9.svg";